function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Public_charging"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.6 240.9v-14.2l-7.2-.1c-3.9 0-7-3.2-7-7.1V162l-25.2-12.6-6.4 12.7 17.3 8.7v48.7c0 11.7 9.5 21.2 21.2 21.3l7.3.1zM134.6 269.3h-28.3V149H78v120.3H49.6V143.7c0-12.7 10.3-23 23-23h38.9c12.7 0 23 10.3 23 23v125.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 255.1h283.5v28.3H0zM212.6 28.3c12.1 0 21.9 4 29.1 11.9 8.8 9.7 13.4 25.2 13.4 44.8 0 19.6-4.6 35-13.4 44.7-7.2 7.9-17 11.9-29.1 11.9-12.1 0-21.9-4-29.1-11.9-8.8-9.7-13.4-25.2-13.4-44.8s4.6-35.1 13.4-44.8c7.2-7.7 16.9-11.8 29.1-11.8m0-28.3c-39.1 0-70.9 28.3-70.9 85s31.7 85 70.9 85c39.1 0 70.9-28.3 70.9-85-.1-56.7-31.8-85-70.9-85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.4 141.7h28.3v127.6h-28.3zM78 42.5H44.5L56.7 0 0 70.9h33.4l-12.1 42.5z"
}))));